import { Component, OnInit, Input } from '@angular/core';
import { EventLogShowService } from '../../services/event-log-show.service';
import { EventLog } from '../../dto/event-log';

@Component({
  selector: 'app-event-log-view',
  templateUrl: './event-log-view.component.html',
  styleUrls: ['./event-log-view.component.css']
})
export class EventLogViewComponent implements OnInit {
  @Input() logs: EventLog[];
  @Input() isLoading = false;
  @Input() caption = 'Logs';
  constructor(
    public eventLogShowService: EventLogShowService
  ) { }

  ngOnInit() {
  }

}
